import React from 'react';

function ServiceRequestInfoSlide({data}) {
    return (
        <div className={'flex'}>
            <div>
                <table className={"w-full thumb-table"}>
                    <tbody>
                    <tr className={"h-[25px]"}>
                        <th>신청제목</th>
                        <td className="thumb-tr" colSpan={3}>{data.title.length > 24 ? data.title.substring(0, 23) + "..." : data.title}</td>
                    </tr>
                    <tr className={"thumb-tr"}>
                        <th>신청번호</th>
                        <td className="min-w-[95px]">{data.serviceApply?.serialNumber}</td>
                        <th>접수번호</th>
                        <td className="min-w-[95px]">{data.serialNumber}</td>
                    </tr>
                    <tr className={"thumb-tr"}>
                        <th>업무그룹</th>
                        <td colSpan={3}>{data.serviceCode?.name}</td>
                    </tr>
                    <tr className={"h-[25px]"}>
                        <td colSpan={4}>
                            <span className="thumb-ag text-[11px] px-[8px] py-[3px] mr-1">요청일 : {data.createdAt} ~ {data.requestCloseDate}</span>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>
    );
}

export default ServiceRequestInfoSlide;